module.exports = __webpack_public_path__ + "img/sv-Funded by the EU_NEG.f2be447.svg";